/**
 * Describes front-end supported feature flags.
 *
 * This does not necessarily mean that a given feature flag is allowed to be used, but that the
 * front-end supports it.
 *
 * Use the enum so that when the feature is approved for production, searching for usage is easier.
 *
 *  
 * Do not reference a flag directly in code.
 * Instead, create a wrapper function in {@link ZbPortalRedesignHelpers}.
 *
 * @see FeatureFlag
 */
export enum FeatureFlagType {
  /** Placeholder for our FeatureFlag infrastructure. Can be commented out when there are active flags. */
  None = 'None',
}
